<template>
    <div class="create_order">
        <div class="shop_top"><shop-top :subnav_show="false" :change_color="true"></shop-top></div>

        <div class="join_over width_center_1200">
            <div class="join_bzt">
                <el-steps :active="1" finish-status="process" simple >
                    <el-step title="我的购物车" icon="el-icon-shopping-cart-full"></el-step>
                    <el-step title="物流地址" icon="el-icon-map-location"></el-step>
                    <el-step title="选择支付" icon="el-icon-mouse"></el-step>
                    <el-step title="支付成功" icon="el-icon-check"></el-step>
                </el-steps>
            </div>
        </div>

        <div class="address_chose width_center_1200">
            <div class="address_chose_title">
                选择送货地址&nbsp;&nbsp;<span style="font-size: 14px; font-weight: normal; float: right;"><router-link to="/user/address"><el-button type="primary">添加新收货地址</el-button></router-link></span>
            </div>
            <div class="address_list">
                <ul>
                    <li :class="v.status==3?'red':''" v-for="(v,k) in address_list.slice(0, 4)" :key="k" @click="set_default(v.id)">
                        <!-- <li :class="v.status==3?'red':''" v-for="(v,k) in address_list.slice(0, 3)" :key="k" @click="set_default(v.id)"> -->
                        <div class="receive_name">{{v.contact}} <span>({{v.phone}})</span></div>
                        <div class="area_info">{{v.province}}{{v.city}}{{v.county}}{{v.street}}{{v.address}}</div>
                        <div :class="v.status==3?'is_default_red':'is_default'"><i class="icon iconfont">&#xe611;</i></div>
                    </li>
                </ul>
            </div>

            <div class="address_chose_title">
                配送方式
            </div>
            <div>
                <el-radio-group v-model="express">
                <el-radio-button label="0">公司配送</el-radio-button>
                <el-radio-button label="1">自提</el-radio-button>
                <el-radio-button label="2" v-if="buygroup">包邮</el-radio-button>
                </el-radio-group> 
            </div>
<br>
            <div class="address_chose_title">
                订单商品信息
            </div>
            <!-- <div class="order_list_title">
                <el-row>
                    <el-col :span="8"><div class="th_title">商品信息</div></el-col>
                    <el-col :span="8"><div class="th_title">厂家</div></el-col>
                    <el-col :span="4"><div class="th_title">单价</div></el-col>
                    <el-col :span="2"><div class="th_title">数量</div></el-col>
                    <el-col :span="2"><div class="th_title">小计</div></el-col>
                </el-row>
            </div> -->

            <!-- <div class="store_list" v-for="(v,k) in befor_order_list" :key="k">
                <div class="store_info">
                    <dl>
                        <dt><el-image :src="v[0].img"></el-image></dt>
                        <dd>{{v[0].spuName}}</dd>
                    </dl>
                    <div class="clear"></div>
                </div>
                <div class="order_list">
                    <ul>
                        <li v-for="(vo,key) in v" :key="key">
                            <el-row>
                                <el-col :span="8"><div class="goods_info">
                                    <dl>
                                        <dt><el-image :src="vo.img" :alt="vo.spuName" :title="vo.spuName" lazy></el-image></dt>
                                        <dd><router-link :to="'/goods/info/'+vo.id"><p>{{vo.spuName}}</p></router-link><p>批号:{{vo.batchno}}</p><p>规格:{{vo.spec}}</p></dd>
                                    </dl>
                                </div></el-col>
                                <el-col :span="8"><div class="companyName" style="line-height:60px;">{{vo.companyName}}</div></el-col>
                                <el-col :span="4"><div class="th_title" style="line-height:60px;">￥{{vo.curPrice}}<del v-if="vo.curPrice < vo.oriPrice" style="color:#C0C4CC; font-size: 12px; margin-left: 5px;">￥{{vo.oriPrice}}</del></div></el-col>
                                <el-col :span="2"><div class="th_title" style="line-height:60px;">x {{vo.qty}}</div></el-col>
                                <el-col :span="2"><div class="x_price" style="line-height:60px;">￥{{vo.curPrice*vo.qty}}</div></el-col>
                            </el-row>
                        </li>
                    </ul>
                </div>
            </div> -->


   <div class="el-table el-table--border">
    <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
     <thead class="has-gutter">
      <tr class="" span="6">
       <th class="is-leaf"><div class="cell">商品图片</div></th>
       <th class="is-leaf"><div class="cell">商品信息</div></th>
       <th class="is-leaf"><div class="cell">单价</div></th>
       <th class="is-leaf"><div class="cell">数量</div></th>
       <th class="is-leaf"><div class="cell">小计</div></th>
      </tr>
     </thead>
     <tbody v-for="(v,k) in befor_order_list" :key="k">
      <tr class="el-table__row" v-for="(vo,key) in v" :key="key">
       <td width="60">
        <div class="cell"><router-link  target='_blank' :to="'/goods/info/'+vo.goodsId"><el-image :src="filePath + vo.img" :alt="vo.spuName" :title="vo.spuName" lazy style="width:60px; height:60px;"></el-image></router-link></div></td>
       <td >
        <div class="cell"><router-link  target='_blank' :to="'/goods/info/'+vo.goodsId"><p>{{vo.spuName}}</p></router-link>
        <p v-if="vo.iscombo == false"><el-tag type="success">批号:{{vo.batchno}}</el-tag>&nbsp;&nbsp;<el-tag>规格:{{vo.spec}}</el-tag>&nbsp;&nbsp;<el-tag type="info">{{vo.companyName}}</el-tag></p>
        </div></td>
       <td  width="120"><div class="cell">￥{{vo.curPrice}}<del v-if="vo.curPrice < vo.oriPrice" style="color:#C0C4CC; font-size: 12px; margin-left: 5px;">￥{{vo.oriPrice}}</del></div></td>
       <td  width="90"><div class="cell">{{vo.qty}}</div></td>
       <td  width="90"><div class="cell">￥{{(vo.curPrice*vo.qty).toFixed(2)}}</div></td>
      </tr>
     </tbody>
    </table>
   </div>
            
            <!-- <div class="remark">
                <div class="remark_title">备注</div>
                <el-input style="margin-top:20px;width:500px;" v-model="remark" show-word-limit type="textarea" maxlength="200"></el-input>
            </div> -->
<br>
   <div class="el-table el-table--border">
    <table cellspacing="0" cellpadding="0" border="0" style="width: 100%;">
     <thead class="has-gutter">
      <tr class="" span="6">
       <th class="is-leaf"><div class="cell">备注</div></th>
       </tr>
     </thead>
     <tbody>
      <tr class="el-table__row">
       <td>
         <div class="cell"><el-input style="padding: 20px;" v-model="remark" show-word-limit type="textarea"></el-input></div></td>
       </tr>
     </tbody>
    </table>
   </div>
            <div class="foot_create_order">
                <div class="total_price">
                    <span>结算：</span>
                    ￥ {{total_price.toFixed(2)}}
                    <font>( 原价:{{total_freight.toFixed(2)}},优惠:{{(total_freight-total_price).toFixed(2)}},不包含运费 )</font>
                    
                </div>
                <!-- <div class="money_pay">
                    <el-checkbox @change="money_page_change" :disabled="user_info.money<=0" v-model="money_pay">余额结算: {{user_info.money||0}} 元</el-checkbox>
                </div> -->
                <div class="clear"></div>
                <div class="foot_create_order_btn"><el-button size="medium" type="danger" v-loading="loading" element-loading-text="请稍后"  @click="create_order">提交订单</el-button></div>
            </div>

            <el-dialog :visible.sync="pwdVisible" width="20%" :show-close="false" title="输入六位支付密码">
                <el-input placeholder="请输入密码" v-model="pay_password" show-password></el-input>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="pwdVisible = false;money_pay=false;">取 消</el-button>
                    <el-button type="danger" @click="submitPayPwd()">确 定</el-button>
                </div>
            </el-dialog>
        </div>

        <shop-foot></shop-foot>
        <!-- vue 回到顶部 -->
        <!--  -->
        <ShopMbar></ShopMbar>
    </div>
</template>

<script>
import ShopTop from "@/components/home/public/head.vue"
import ShopFoot from "@/components/home/public/shop_foot.vue"
import ShopMbar from "@/components/home/public/mui_mbar_tabs.vue"  //右侧固定快捷导航
export default {
    components: {
        ShopTop,
        ShopFoot,
        ShopMbar, //右侧固定快捷导航
    },
    props: {},
    data() {
      return {
          address_list:[],
          befor_order_list:[],
          //user_info:{},
          total_price:0,
          total_freight:0,
          remark:'', // 备注
          money_pay:false, // 余额支付
          pwdVisible:false, // 支付密码输入
          pay_password:'',
        //   diasabledInput: false,
          filePath:null,
          express:0,
          buygroup:false, //是否是团购，是则包邮
          loading: false,
      };
    },
    watch: {},
    computed: {},
    methods: {

        //附件路径
        filepath:function(){ 
             this.$get(this.$api.filepath,{platId:this.$platId}).then(res=>{
                this.filePath = res.data[0].config;
            });
        },

        //收货地址列表
        get_address_list:function(){
            this.$get(this.$api.getAddressList).then(res=>{
                this.address_list = res.data;
                // 如果没有设置默认地址则设置一个
                if(this.address_list.length>0){
                    let a = 4;
                    this.address_list.forEach(addressRes=>{
                        if(addressRes.status == 3){
                            this.addressId = addressRes.id;
                            a += 1;
                        }
                    });
                    if(a==4){
                        this.set_default(this.address_list[0].id);
                    }
                }
              
            });
        },
        //设置默认收货地址
        set_default:function(id){
            this.$put(this.$api.setDefaultAddress,[{id:id,status:3}]).then(()=>{
                this.get_address_list();
                return this.$message.success('修改默认地址成功');
            });
        },
        create_order:function(){
            if(this.loading === true) {
                return;
            }
            this.loading = true;
            this.beforePlaceOrde();
            setTimeout(()=>{
                this.createOrdersResults();
            },1500);
        },
        createOrder:function(){
                        if(this.$isEmpty(localStorage.getItem('token'))){
                            this.$message.error('请先登录！');
                            return this.$router.push('/user/login');
                        }
                        // 判断是否有收货地址
                        if(this.address_list<=0){
                            return this.$message.error('请先设置收货地址！');
                        }

                        //  如果没有设置默认则设置一个默认地址
                        if(this.address_list.length>0){
                            let a = 4;
                            this.address_list.forEach(addressRes=>{
                                if(addressRes.status == 3){
                                    a += 1;
                                }
                            });
                            if(a==4){
                                this.set_default(this.address_list[0].id);
                            }
                        }
                        //生成订单并支付
                        //this.$post(this.$api.homeCreateOrder,{ids:this.$route.params.info,totalMoney:this.total_price}).then(res=>{
                        let data = {};
                        if(this.total_price <= 0){
                            this.$message.error('订单金额有误，即将返回购物车');
                            return this.$router.push('/cart/index');
                        }
                        data.ids = this.$route.params.info;    // 购物车ID
                        data.totalMoney = this.total_price;    // 金额
                        data.couponId = null;
                        data.remark = this.remark;
                        data.couponmony =null;
                        data.addressId =this.addressId;
                        this.$post(this.$api.homeCreateOrder ,{"rows":[{ids:this.$route.params.info,totalMoney:this.total_price,couponId:'',remark:this.remark,couponmony:'',addressId:this.addressId,platId:this.$platId}],"logistics":{express:this.express}}).then(res=>{ 
                            if(res.code == 500){
                                this.loading = false;
                                return this.$message.error(res.message);
                            }else{
                                this.loading = false;
                                this.$message.success('订单创建成功，等待支付');
                                this.orderId = res.data;
                                //this.orderTime = res.data;
                                return this.$router.push('/order/chose_pay/'+this.orderId)
                            }

                        });
                        // setTimeout(()=>{
                        //     this.diasabledInput = false 
                        // },1500);
            
        },
        // 根据购物车的数据或者商品的数据来获取订单的数据
        get_order_list:function(){
            // this.$post(this.$api.homeGetBeforOrder,{type:this.$route.params.type,info:this.$route.params.info}).then(res=>{
            this.$get(this.$api.homeGetBeforOrder,{ids:this.$route.params.info,platId:this.$platId}).then(res=>{
                this.befor_order_list = res.data;
                if(!this.befor_order_list){
                    return
                }
                this.befor_order_list.forEach(res=>{
                    res.forEach(goodsRes=>{
                        this.total_price += (goodsRes.curPrice*goodsRes.qty);
                        this.total_freight += (goodsRes.oriPrice*goodsRes.qty);
                    });
                });
                // if(this.befor_order_list){
                //     this.befor_order_list.forEach(res=>{
                //         res.forEach(goodsRes=>{
                //             this.total_price += (goodsRes.curPrice*goodsRes.qty);
                //         });
                //     });
                // }
            });
        },

        //创建订单后返回信息提示
        createOrdersResults:function(){
            this.$get(this.$api.createOrdersResults).then(res=>{
                if(res.code == 200){
                    this.createOrder();
                }else{
                    this.$message.error(res.message);
                    this.loading = false;
                }
            });
        },
        
        //创建订单前
        beforePlaceOrde:function(){
            this.$post(this.$api.beforePlaceOrder,{"rows":[{ids:this.$route.params.info,totalMoney:this.total_price,couponId:'',remark:this.remark,couponmony:'',addressId:this.addressId}],"logistics":{express:this.express},platId:this.$platId}).then(res=>{ 
                if(res.code==200){
                    // this.$message.success(res.message);
                }else{
                    this.loading = false;
                    this.$message.error(res.message);
                }
            });
        },

        // 计算运费
        count_freight:function(){

        },
        // 获取用户信息
        // get_user_info:function(){
        //     this.$get(this.$api.homeEditUserInfo).then(res=>{
        //         this.user_info = res.data;
        //     });
        // },
        money_page_change:function(e){
            if(e){
                this.pwdVisible = true;
            }
        },
        //余额支付
        // submitPayPwd:function(){
        //     this.$post(this.$api.homeCheckPayPassword,{pay_password:this.pay_password}).then(res=>{
        //         if(res.code == 200){
        //             this.money_pay = true;
        //             this.pwdVisible = false;
        //         }else{
        //             this.money_pay = false;
        //             return this.$message.error(res.message);
        //         }
        //     });
        // }

         get_user_info:function(){
            this.$get(this.$api.homeGetUserInfo).then(res=>{
                if(res.code == 200){
                    this.user_info = res.data;
                }else{
                    this.$router.push('/user/login');
                }
            });
        },


    },
    created() {
        this.get_address_list();
        this.get_order_list();
        this.filepath();
        this.get_user_info();
        //this.get_user_info();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.create_order{
    background: #fff;
}
.remark{
    margin-top:40px;
    color:#666;
    .remark_title{
        background: #f2f2f2;
        line-height: 40px;
        padding-left: 20px;
    }
}
.empty_address{
    margin-bottom: 30px;
    line-height: 105px;
    border:3px solid #efefef;
    border-radius: 3px;
    text-align: center;
    width: 292px;
    height: 105px;
    span{
        color:#409EFF;
    }
    a:hover{
        color:#409EFF;
    }
}
.join_bzt{
    margin-top:40px;
}
.foot_create_order{
    margin-top: 50px;
    float: right;
    margin-right: 30px;
    .total_price{
        font-size: 28px;
        color:#409EFF;
        line-height: 28px;
        span{
            float: left;
            font-size: 14px;
            color:#333;
            
        }
        font{
            float: right;
            font-size: 14px;
            color:#666;
            margin-left: 20px;
        }
    }
    .money_pay{
        line-height: 28px;
        float: right;
        color:#666;
        font-size: 12px;
        margin-top: 20px;
    }
    .foot_create_order_btn{
        float:right;
        margin-top: 20px;
        margin-bottom: 40px;
    }
}
.store_list{
    .store_info{
        margin-top: 20px;
        margin-left: 15px;
        
        dl dt{
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: #f1f1f1;
            float: left;
            margin-right: 15px;
        }
        dl dd{
            float: left;
            line-height: 30px;
        }
    }
    ul li{
        border-bottom: 1px solid #efefef;
        padding-bottom: 20px;
        margin-bottom: 20px;
        .x_price{
            color:#409EFF;
        }
        text-indent: 20px;
    }
    ul li .goods_info{
        text-indent: 0px;
    }
    ul li:last-child{
        border-bottom: none;
        padding-bottom: 0px;
        margin-bottom: 0px;
    }
    .order_list{
        // margin-top: 20px;
        color:#666;
        font-size: 12px;
        border:1px solid #efefef;
        padding:20px;
        line-height: 40px;
        .goods_info{
            dl dt{
                width: 40px;
                height: 40px;
                background: #f8f8f8;
                float: left;
                margin: 10px 15px 10px 0;
            }
            dl dd{
                line-height: 20px;
            }
        }
    }
}
.order_list_title{
    color:#666;
    background: #f2f2f2;
    line-height: 40px;
    text-indent: 20px;
}
.address_chose{
    margin-top: 25px;
    font-size: 14px;
    .address_chose_title{
        font-size: 16px;
        clear: both;
        font-weight: bold;
        padding-bottom: 20px;
    }
    .address_list{
        ul:after{
            content:'';
            display: block;
            clear:both;
        }
        margin-bottom:30px; 
        ul li{
            float: left;
            box-sizing: border-box;
            width: 292px;
            height: 105px;
            border-radius: 3px;
            border:2px solid #efefef;
            margin-right: 10px;
            margin-bottom: 10px;
            padding:20px;
            position: relative;
            cursor: pointer;
            .receive_name{
                margin-bottom: 10px;
                font-weight: bold;
                line-height: 18px;
                span{
                    font-weight: normal;
                    color:#666;
                    font-size: 12px;
                }
            }
            .area_info{
                color:#666;
            }
            .is_default{
                i{
                    font-size: 20px;
                }
                position: absolute;
                right: -10px;
                bottom: -8px;
            }
            .is_default_red{
                i{
                    font-size: 20px;
                }
                position: absolute;
                right: -10px;
                bottom: -8px;
                color:#F56C6C;
            }
        }
        ul li.red{
            border-color: #F56C6C;
        }
        ul li:nth-child(4n){
            margin-right: 0;
        }
    }
}
.el-table thead th {
    background: #f5f7fa;
}
.el-table p{
    margin: 5px auto;
}
.el-table td{
    padding: 10px;
}
</style>